import { ODataSelect } from "@iconics/core";
import { ForwarderTypeEnum } from "../../../../Providers.FadxPlatformApiClientV2/FadxPlatformApiClientV2";

export class DataHubPublisher extends ODataSelect
{
    public Id = 0;
    public Name = "";
    public DisplayName = "";
    public ForwarderEventHubID = 0;
    public ModuleConfigurationEntityId = "";
    public ForwarderType?: ForwarderTypeEnum;
    public "@odata.etag" = "";
    
    override toSelect(): string
    {
        return ''
    }
}

export class DataHubCredentials extends ODataSelect
{
    public Id = 0;
    public Name = "";
    public DisplayName = "";
    public ConnectionString = "";
    public AccessKey = "";
    public "@odata.etag" = "";
    
    override toSelect(): string
    {
        return ''
    }
}